import type { Thing, WithContext } from 'schema-dts';

interface LinkedDataJsonProps<T extends Thing> {
  id: string;
  schema: WithContext<T>;
}

export function LinkedDataJson<T extends Thing>({ id, schema }: LinkedDataJsonProps<T>) {
  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      key={id}
    />
  );
}
